import React from 'react';

const SvgComponent = (props) => (
  <svg viewBox="0 0 18 18" width="1em" height="1em" {...props}>
    <path d="M15.168 3.436A7.213 7.213 0 0 0 9 0a7.212 7.212 0 0 0-6.17 3.44 4.136 4.136 0 0 0-.302 3.716L5 13.266V16l2 2h4l2-2v-2.734l2.471-6.113a4.132 4.132 0 0 0-.303-3.717zM11.8 15.503L10.503 16.8H7.497L6.2 15.503V13h5.6v2.503zm-2-3.703H8.2V6a.801.801 0 0 1 1.6 0v5.8zm4.559-5.096l-2.06 5.096H11V6a2 2 0 0 0-4 0v5.8H5.701l-2.06-5.093a2.934 2.934 0 0 1 .209-2.636A6.02 6.02 0 0 1 9 1.199a6.02 6.02 0 0 1 5.148 2.869c.484.78.562 1.765.211 2.636z" />
  </svg>
);

export default SvgComponent;
